import * as stylex from "@stylexjs/stylex";
import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import { type ReactNode } from "react";

export function StoreColumns({
  coworldName,
  main,
  aside,
  spacing: columnSpacing = "standard",
}: {
  readonly spacing?: "standard" | "wide";
  readonly coworldName: string;
  readonly main: ReactNode;
  readonly aside: ReactNode;
}) {
  return (
    <div {...stylex.props(styles.outer)}>
      <div {...stylex.props(styles.lane)}>
        <div
          {...stylex.props(
            styles.columns,
            columnSpacing === "wide" && styles.wideColumns,
          )}
        >
          <div {...stylex.props(styles.main)}>{main}</div>
          <aside
            aria-label={`More about ${coworldName}`}
            {...stylex.props(styles.aside)}
          >
            {aside}
          </aside>
        </div>
      </div>
    </div>
  );
}

const styles = stylex.create({
  outer: {
    containerType: "inline-size",
    width: "100%",
    backgroundColor: colors.background,
  },
  lane: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 1200,
    marginInline: "auto",
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is([data-rail] *)": spacing.space32,
      },
    },
    paddingBlock: {
      default: spacing.space40,
      "@media (min-width: 1024px)": spacing.space48,
    },
  },
  columns: {
    display: "grid",
    columnGap: spacing.space24,
    rowGap: spacing.space40,
    gridTemplateColumns: {
      default: "minmax(0, 1fr)",
      "@container (min-width: 880px)": "minmax(0, 1fr) 300px",
      "@container (min-width: 1120px)": "minmax(0, 1fr) 328px",
    },
  },
  wideColumns: {
    columnGap: {
      default: spacing.space24,
      "@container (min-width: 880px)": spacing.space48,
      "@container (min-width: 1120px)": 72,
    },
  },
  main: {
    containerType: "inline-size",
    display: "flex",
    minWidth: 0,
    flexDirection: "column",
  },
  aside: {
    display: "flex",
    minWidth: 0,
    flexDirection: "column",
    gap: spacing.space40,
  },
});
